import React from 'react';

const escapeRegExp = (str = '') => str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');

const Highlighted = ({
  text = '',
  highlight = '',
  regularTag: RegularTag = 'span',
  highlightTag: HighlightTag = 'em',
  className = '',
}) => {
  if (!highlight.trim()) {
    return <RegularTag className={className}>{text}</RegularTag>;
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
  const parts = text.split(regex);
  return (
    <RegularTag className={className}>
      {parts
        .filter((part) => part)
        .map((part, i) =>
          regex.test(part) ? (
            <HighlightTag key={i}>{part}</HighlightTag>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
    </RegularTag>
  );
};

export default Highlighted;
